/** Formatting shared by the bulk registration pages. */

export function money(cents: number): string {
  return `$${(cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/** "Sat, Apr 18" — compact date for list rows. */
export function shortDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
}

export const STATUS_LABEL: Record<string, string> = {
  confirmed: 'Confirmed',
  pending_approval: 'Pending approval',
  pending_payment: 'Awaiting payment',
};
